export default {
  install: (Vue, options) => {
    const LOGOUT = "user/logout";

    Vue.prototype.$helpers = {
      login() {
        options.$router.push("/login");
      },
      logout() {
        options.$store
          .dispatch(LOGOUT)
          .then(() => options.$router.push("/"))
          .catch(err => console.log(err));
      },
      handleFeedback(e) {
        let result = false;
        switch (e) {
          case "invalidToken":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/expired"))
              .catch(err => console.log(err));
            break;
          case "NoUserAccessRight":
            result = true;
            options.$store
              .dispatch(LOGOUT)
              .then(() => options.$router.push("/denied"))
              .catch(err => console.log(err));
            break;
        }
        return result;
      },
      alert(title, message, variant) {
        return options.$swal(title, message, variant);
      },
      showDialog(title, message, variant) {
        options.$swal(title, message, variant);
      },
      showToast(caption, message, variant) {
        options.$swal(title, message, variant);
      },
      getNumberClass(n) {
        let result = "text-primary";
        if (n < 0) {
          result = "text-danger";
        } else if (n == 0) {
          result = "text-zero";
        }
        return result;
      },
      selectText: function(element) {
        let doc = document;
        let text = doc.getElementById(element);
        let range, selection;

        if (doc.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(text);
          range.select();
        } else if (window.getSelection) {
          selection = window.getSelection();
          range = document.createRange();
          range.selectNodeContents(text);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      },
      getCommRateList: function(range) {
        let cmRange = [];
        if (range) {
          let increment = 0.0;
          let div = Math.ceil(range / 0.05);
          for (let i = 0; i <= div; i++) {
            let val = parseFloat(increment.toFixed(2));
            increment = increment + 0.05;
            cmRange.push({ value: val, text: val + "%" });
          }
        } else {
          cmRange.push({ value: 0, text: "0%" });
        }
        return cmRange;
      },
      getPTRateList: function(range) {
        let ptRange = [];
        if (range) {
          let increment = 0.0;
          let div = Math.ceil(range / 0.5);
          for (let i = 0; i <= div; i++) {
            let val = parseFloat(increment.toFixed(2));
            increment = increment + 0.5;
            ptRange.push({ value: val, text: val + "%" });
          }
        } else {
          ptRange.push({ value: 0, text: "0%" });
        }
        return ptRange;
      },
      getTierName: function(id, isUpline) {
        let length = id.length;
        let name = "";
        switch (length) {
          case 2:
            name = isUpline ? this.getUplineName(6) : this.getUplineName(5);
            break;
          case 4:
            name = isUpline ? this.getUplineName(5) : this.getUplineName(4);
            break;
          case 6:
            name = isUpline ? this.getUplineName(4) : this.getUplineName(3);
            break;
          case 8:
            name = isUpline ? this.getUplineName(3) : this.getUplineName(2);
            break;
          case 11:
            name = isUpline ? this.getUplineName(2) : this.getUplineName(1);
            break;
        }
        // console.log("test: ", length);
        return name;
      },
      getUplineName: function(account_type) {
        let account_name = "";
        switch (account_type) {
          case 6:
            account_name = options.$t.messages[options.$t.locale].ui.share_holder;
            break;
          case 5:
            account_name = options.$t.messages[options.$t.locale].ui.super_senior;
            break;
          case 4:
            account_name = options.$t.messages[options.$t.locale].ui.senior;
            break;
          case 3:
            account_name = options.$t.messages[options.$t.locale].ui.master;
            break;
          case 2:
            account_name = options.$t.messages[options.$t.locale].ui.agent;
            break;
          case 1:
            account_name = options.$t.messages[options.$t.locale].ui.member;
            break;
          default:
            account_name = options.$t.messages[options.$t.locale].ui.company;
            break;
        }

        return account_name;
      },
      getTeamClass(n, side) {
        if (n.bet_type == "HDP" || n.bet_type == "HDPH") {
          if (n.team_g == n.home_team_id && side == 0) {
            return "text-danger";
          } else if (n.team_g == n.away_team_id && side == 1) {
            return "text-danger";
          } else {
            return "text-info";
          }
        } else {
          return "";
        }
      },
      getBetTeam(item) {
        let betTeamID = item.bet_team_id;
        let homeTeamID = item.home_team_id;
        let awayTeamID = item.away_team_id;

        if (betTeamID == homeTeamID) {
          return item.home_team_name;
        }

        if (betTeamID == awayTeamID) {
          return item.away_team_name;
        }
      },
      isCompany: function(account_type) {
        return account_type == 6 ? true : false;
      },
      isMemberLevel: function(account_type) {
        return account_type == 1;
      },
      isAgentLevel: function(account_type) {
        return account_type == 2;
      },
      copyAllUpline_title() {
        return options.$t.messages[options.$t.locale].message.copy_all_upline;
      },
      copyAllAccount_title() {
        return options.$t.messages[options.$t.locale].message.copy_all_account;
      },
      copyAllRemaining_title() {
        return options.$t.messages[options.$t.locale].message.copy_all_remaining;
      },
      copyAllMin_title() {
        return options.$t.messages[options.$t.locale].message.copy_all_min;
      },
      copyAllMinBet_title() {
        return options.$t.messages[options.$t.locale].message.copy_all_min_bet;
      },
      copyAllMaxBet_title() {
        return options.$t.messages[options.$t.locale].message.copy_all_max_bet;
      },
      copyAllMaxPerMatch_title() {
        return options.$t.messages[options.$t.locale].message.copy_all_max_per_match;
      },
      numberFormat: function(value) {
        let result = "";
        if (value) {
          let rawValue = parseInt(value.toString().replace(/,/g, ""));
          result = rawValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return result;
      },
      convertNumber: function(value) {
        return parseInt(value.toString().replace(/,/g, ""));
      },
      settlementFormat: function(value) {
        let result = "";
        if (value) {
          let rawValue = value.toString().replace(/,/g, "");
          let part1 = parseFloat(rawValue)
            .toFixed(2)
            .split(".")[0];
          let part2 = parseFloat(rawValue)
            .toFixed(2)
            .split(".")[1];
          result = part1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + part2;
        } else {
          result = "0";
        }
        return result;
      },
      convertSettlementNumber: function(value) {
        return parseFloat(value.toString().replace(/,/g, "")).toFixed(2);
      },
      companyMaxPT() {
        return 100;
      },
      companyMaxComm() {
        return 0.8;
      },
      companyMinBet() {
        return 1;
      },
      companyMaxBet() {
        return 100000000000;
      },
      companyMaxPerMatch() {
        return 100000000000;
      },
      getPTSB: function(response, betType, sportType, type) {
        let result = "";
        let item = response;
        item.forEach(value => {
          if (value.bet_type == betType && value.sport_type == sportType) {
            result = value[type];
          }
        });
        return result;
      },
      getBetClass(n) {
        if (n.bet_type == "HDP" || n.bet_type == "HDPH") {
          if (n.bet_team_id == n.home_team_id && n.home_team_id == n.team_g) {
            return "text-danger";
          } else if (n.bet_team_id == n.away_team_id && n.away_team_id == n.team_g) {
            return "text-danger";
          } else {
            return "text-info";
          }
        }
      },
      getBetDetail(n) {
        let result = "";
        switch (n.bet_type) {
          case "HDP":
          case "HDPH":
            if (n.bet_team_id == n.home_team_id) {
              result = n.home_team_name;
            } else if (n.bet_team_id == n.away_team_id) {
              result = n.away_team_name;
            }
            break;
          case "ML":
          case "MLH":
            result = n.home_away == 1 ? n.home_team_name : n.away_team_name;
            break;
          case "OE":
          case "OEH":
            result = n.home_away == 1 ? options.$t.messages[options.$t.locale].ui.odd : options.$t.messages[options.$t.locale].ui.even;
            break;
          case "OU":
          case "OUH":
            result = n.home_away == 1 ? options.$t.messages[options.$t.locale].ui.over : options.$t.messages[options.$t.locale].ui.under;
            break;
          case "1X2":
          case "1X2H":
            if (n.home_away == 1) {
              result = n.home_team_name;
            } else if (n.home_away == 2) {
              result = n.away_team_name;
            } else if (n.home_away == 3) {
              result = options.$t.messages[options.$t.locale].ui.draw;
            }
            break;
          case "CS":
          case "CSH":
          case "TG":
          case "TGH":
          case "OR":
            result = n.criteria1;
            break;
          case "DC":
          case "DCH":
            if (n.criteria1 == "HD") {
              result = options.$t.messages[options.$t.locale].ui.home + "/" + options.$t.messages[options.$t.locale].ui.draw;
            } else if (n.criteria1 == "HA") {
              result = options.$t.messages[options.$t.locale].ui.home + "/" + options.$t.messages[options.$t.locale].ui.away;
            } else if (n.criteria1 == "DA") {
              result = options.$t.messages[options.$t.locale].ui.draw + "/" + options.$t.messages[options.$t.locale].ui.away;
            } else {
              result = n.criteria1;
            }
            break;
          case "FGLG":
          case "FGLGH":
            if (n.criteria1 == "HFG") {
              result = options.$t.messages[options.$t.locale].ui.home + " " + options.$t.messages[options.$t.locale].ui.first_goal;
            } else if (n.criteria1 == "AFG") {
              result = options.$t.messages[options.$t.locale].ui.away + " " + options.$t.messages[options.$t.locale].ui.first_goal;
            } else if (n.criteria1 == "HLG") {
              result = options.$t.messages[options.$t.locale].ui.home + " " + options.$t.messages[options.$t.locale].ui.last_goal;
            } else if (n.criteria1 == "ALG") {
              result = options.$t.messages[options.$t.locale].ui.away + " " + options.$t.messages[options.$t.locale].ui.last_goal;
            } else if (n.criteria1 == "NG") {
              result = options.$t.messages[options.$t.locale].ui.no_goal;
            } else {
              result = n.criteria1;
            }
            break;
          case "HTFT":
            if (n.criteria1 == "HH") {
              result = options.$t.messages[options.$t.locale].ui.hh;
            } else if (n.criteria1 == "HD") {
              result = options.$t.messages[options.$t.locale].ui.hd;
            } else if (n.criteria1 == "HA") {
              result = options.$t.messages[options.$t.locale].ui.ha;
            } else if (n.criteria1 == "DH") {
              result = options.$t.messages[options.$t.locale].ui.dh;
            } else if (n.criteria1 == "DD") {
              result = options.$t.messages[options.$t.locale].ui.dd;
            } else if (n.criteria1 == "DA") {
              result = options.$t.messages[options.$t.locale].ui.da;
            } else if (n.criteria1 == "AH") {
              result = options.$t.messages[options.$t.locale].ui.ah;
            } else if (n.criteria1 == "AD") {
              result = options.$t.messages[options.$t.locale].ui.ad;
            } else if (n.criteria1 == "AA") {
              result = options.$t.messages[options.$t.locale].ui.aa;
            } else {
              result = n.criteria1;
            }
            break;
        }

        return result;
      },
      getDisplayBall(n) {
        let result = "";
        if (n.bet_type == "HDP" || n.bet_type == "HDPH") {
          if (n.bet_team_id == n.home_team_id && n.home_team_id == n.team_g) {
            result = -n.ball;
          } else if (n.bet_team_id == n.away_team_id && n.away_team_id == n.team_g) {
            result = -n.ball;
          } else {
            result = n.ball;
          }
        } else {
          result = n.ball_display;
        }

        if (n.bet_type_share == "HDPMMO") {
          // result = result + " (" + n.criteria2 + ")";
          if (n.bet_team_id == n.home_team_id && n.home_team_id == n.team_g) {
            result = -n.ball_display + " (" + n.criteria2 + ")";
          } else if (n.bet_team_id == n.away_team_id && n.away_team_id == n.team_g) {
            result = -n.ball_display + " (" + n.criteria2 + ")";
          } else {
            result = n.ball_display + " (" + n.criteria2 + ")";
          }
        }

        return result;
      },
      displayBetDetail: function(item) {
        return item.company_pt * 0.01 + " x " + item.bet_member;
      },
      getOddsType(n) {
        var result = "";
        switch (n.odds_type) {
          case 1:
            result = n.criteria2 != "" && n.criteria2 != null ? "(MMO)" : "(MY)";
            break;
          case 2:
            result = "(HK)";
            break;
          case 3:
            result = "(ID)";
            break;
          case 4:
            result = "(DEC)";
            break;
        }
        return result;
      },
      showWinStatus: function(item) {
        let payout = item.payout_odds;
        let display = item.odds_display;
        let status = item.status;
        let detail_status = item.detail_status;
        let result = "";
        switch (true) {
          case payout === 0:
            result = options.$t.messages[options.$t.locale].ui.lose;
            break;
          case payout > 0 && payout < 1:
            result = options.$t.messages[options.$t.locale].ui.lose_half;
            break;
          case payout === 1:
            if (detail_status == 2) {
              result = options.$t.messages[options.$t.locale].ui.void;
            } else {
              if (status == 5) {
                result = options.$t.messages[options.$t.locale].ui.abandoned;
              } else if (status == 2) {
                result = options.$t.messages[options.$t.locale].ui.cancel;
              } else {
                result = options.$t.messages[options.$t.locale].ui.draw_cancel;
              }
            }
            break;
          case payout < display && payout > 1:
            result = options.$t.messages[options.$t.locale].ui.win_half;
            break;
          case payout > 1:
            result = options.$t.messages[options.$t.locale].ui.won;
            break;
          default:
            result = options.$t.messages[options.$t.locale].ui.running;
            break;
        }

        return result.toUpperCase();
      },
      showWinStatusMMO: function(item) {
        let payout = item.payout_odds;
        let display = item.odds_display;
        let status = item.status;
        let detail_status = item.detail_status;
        let result = "";
        switch (true) {
          case payout === 0:
            result = options.$t.messages[options.$t.locale].ui.lose;
            break;
          case payout > 0 && payout < 1:
            result = options.$t.messages[options.$t.locale].ui.lose_half;
            break;
          case payout === 1:
            if (detail_status == 2) {
              result = options.$t.messages[options.$t.locale].ui.void;
            } else {
              if (status == 5) {
                result = options.$t.messages[options.$t.locale].ui.abandoned;
              } else if (status == 2) {
                result = options.$t.messages[options.$t.locale].ui.cancel;
              } else {
                result = options.$t.messages[options.$t.locale].ui.draw_cancel;
              }
            }
            break;
          case payout > 1 && payout < 2:
            result = options.$t.messages[options.$t.locale].ui.win_half;
            break;
          case payout === 2:
            result = options.$t.messages[options.$t.locale].ui.won;
            break;
          default:
            result = options.$t.messages[options.$t.locale].ui.running;
            break;
        }

        return result.toUpperCase();
      },
      passwordFormat(value) {
        const containsUppercase = /[A-Z]/.test(value);
        const containsLowercase = /[a-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        //const containsSpecial = /[#?!@$%^&*-]/.test(value)
        return containsUppercase && containsLowercase && containsNumber;
      },
      rowClassBit: function(item) {
        if (item == null) return
        if (item == false) return 'bg-yellow'
      },
      fontClassName(item, isLink) {
        isLink = isLink || false;
        if (parseFloat(item) < 0)
          return 'text-danger';
        else if (parseFloat(item) == 0)
          return '';
        else {
          if (isLink == true)
            return 'text-info';
          else
            return '';
        }
      },
    };
  }
};
